import React from 'react';
import { generateFormData } from '../util/submit';
import * as API_REQ from '../apis/req';
import * as type from '../constants/type';
import base from './base';
import ConformRuleDialog from '../components/dialog/conform-rule';
import ReactDOM  from 'react-dom';
export const conformRule = function(callback){
    //设置合规校验事件
    // window.WfForm.registerCheckEvent(window.WfForm.OPER_SUBMIT, function(callback){  //提交按钮上注册合规校验
      const formParams = generateFormData();
      let isFirstRequest = true, needStop = false;
      let params  = { ...formParams, ...base.globalStore.baseParam, useThread: 1};
      let getConformFunc = () => {
        if(isFirstRequest) {
          isFirstRequest = false;
          params = { ...params, isReset: 1};
        } else {
          delete params.isReset;
        }
        if(needStop) return
        if(base.globalStore.commonParam.freeNodeExtendNodeId && base.globalStore.commonParam.freeNodeExtendNodeId>0){
          params.nodeid = base.globalStore.commonParam.freeNodeExtendNodeId;
        }
        API_REQ.conformCheck(params).then(data => {
          let { result } = data;
          if(!result.end) {
            let _this = window;
            _this.timer = setTimeout(() => {
              _this.timer && clearTimeout(_this.timer);
              if(needStop) {
                base.globalStore.controlDialogVisible(type.CONFORM_RULE, false);
                return 
              } 
              getConformFunc();
            }, 1000);
          } else {
            if(result.allPass) {
                let _this = window;
                _this.timer = setTimeout(() => {
                    _this.timer && clearTimeout(_this.timer);
                    base.conformRuleStore.setHasCheckedConformRule(true);   
                }, 500);
              base.globalStore.changeSubmitParam({needConformCheck: '0'});
              callback();
            }
          }
          base.conformRuleStore.setHasCheckedConformRule(false);
          base.conformRuleStore.setConformRuleInfo(data);
          !needStop && base.globalStore.controlDialogVisible(type.CONFORM_RULE, true);
          base.conformRuleStore.setConformRuleSubmitEvent(callback, ()=>{needStop = true; base.globalStore.controlDialogVisible(type.CONFORM_RULE, false);});
        });
      };
      getConformFunc();
    // });
}
const showRuleCompareResult = () => {
  const formParams = generateFormData();
  let params  = { ...formParams, ...base.globalStore.baseParam};
  let obj = null;
  if(!document.getElementById('conform-rule-container')) {
    obj = document.createElement('div');
    obj.setAttribute('id', 'conform-rule-container');
    document.body.appendChild(obj);
  } else {
    obj = document.getElementById('conform-rule-container');
  }
  ReactDOM.render( <ConformRuleDialog conformRuleStore={base.conformRuleStore} isFromCheckResult={true} formParams={params}/>,obj);
}
window.showRuleCompareResult = showRuleCompareResult;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/conformRuleUtil.js